import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=4672e4c2&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=4672e4c2&prod&scoped=true&lang=css&"
import style1 from "./profile.vue?vue&type=style&index=1&id=4672e4c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672e4c2",
  null
  
)

export default component.exports